export const SELLER_SESSION_EXPIRED_CODE = "SELLER_SESSION_EXPIRED";

export type SellerSessionFailureKind = "expired" | "invalid" | "access-change" | null;

export function getSellerLoginUrl(locale: string, _storeSlug?: string | null) {
  void _storeSlug;
  return `/${locale}/login`;
}

export function classifySellerSessionFailure(
  status: number,
  errorCode?: string | null,
): SellerSessionFailureKind {
  if (status !== 401 && status !== 403) {
    return null;
  }

  if (errorCode === SELLER_SESSION_EXPIRED_CODE) {
    return "expired";
  }

  if (status === 403 && (
    errorCode === "STORE_MEMBERSHIP_INACTIVE" ||
    errorCode === "STORE_CAPABILITY_REQUIRED"
  )) return "access-change";

  // The cookie is still valid when a particular operation is forbidden.
  // Redirecting these refusals to login reopens the same authenticated screen.
  if (status === 403 && (
    errorCode === "SELLER_PERMISSION_DENIED" ||
    errorCode === "SELLER_SUBSCRIPTION_RESTRICTED" ||
    errorCode === "ORDER_LOCKED_UNSETTLED" ||
    errorCode?.startsWith("META_")
  )) {
    return null;
  }

  return "invalid";
}
